export default function autoUpdate(name, url) {
  return {
    name,
    url,

    init() {
      this.$el.addEventListener("change", () => this.handleChange());
    },

    handleChange() {
      const body = { values: {} };
      body.values[this.name] = this.$root.value;
      const token = document.querySelector('meta[name=csrf-token]')?.getAttribute('content');
      const request = new Request(this.url, {
        method: 'PATCH',
        headers: {
          'content-type': 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify(body),
      })
      fetch(request)
    }
  }
}
